import { Sparkles } from "lucide-react";
import { cn } from "@/lib/utils";

interface AIBadgeProps {
  className?: string;
  children?: React.ReactNode;
}

export function AIBadge({ className, children }: AIBadgeProps) {
  return (
    <span className={cn("ai-badge", className)}>
      <Sparkles className="h-3 w-3" />
      {children || "AI-Generated"}
    </span>
  );
}

interface AIDisclaimerProps {
  className?: string;
  children?: React.ReactNode;
}

export function AIDisclaimer({ className, children }: AIDisclaimerProps) {
  return (
    <p className={cn("ai-disclaimer", className)}>
      {children || "AI-generated content. Always verify medical information with current guidelines and expert sources."}
    </p>
  );
}

interface AISourceCitationProps {
  source: string;
  url?: string;
  className?: string;
}

export function AISourceCitation({ source, url, className }: AISourceCitationProps) {
  if (url) {
    return (
      <a 
        href={url} 
        target="_blank" 
        rel="noopener noreferrer"
        className={cn("ai-source-citation", className)}
      >
        {source}
      </a>
    );
  }
  
  return (
    <span className={cn("ai-source-citation cursor-default", className)}>
      {source}
    </span>
  );
}
